import { forwardRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import styled from "styled-components";
import Button from "../buttons/button";
import SelectInput from "../inputs/select";
import TextInput from "../inputs/text";
import { FormattedMessage, useIntl } from "react-intl";

const StyledFormButton = styled(Button)`
    min-width: 100%;
    display: block;
    background: rgb(227, 129, 70);
    border-radius: 45px;
    border: unset;
    outline: none;
    font-weight: 600;
    color: rgb(249, 241, 221);
    font-size: 28px;
    max-width: 320px;
    height: 87px;
    line-height: 87px;
    text-align: center;
    width: 100%;
    text-decoration: unset;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
    @media (max-width: 1199px) {
        font-size: calc(16px + (12) * ((100vw - 320px) / (1200 - 320)));
        line-height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 599px) {
        margin: auto;
        font-size: 20px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

type BookDemoFormFields = {
    firstName: string;
    lastName: string;
    companyName: string;
    industry: string;
    email: string;
    jobTitle: string;
    phone?: string;
};

type BookDemoFormProps = {
    id?: string;
};

const BookDemoForm = forwardRef<HTMLFormElement, BookDemoFormProps>(({ id }, ref) => {
    const { register, handleSubmit } = useForm<BookDemoFormFields>({
        shouldUseNativeValidation: true,
    });
    const [isBookRequested, setIsBookRequested] = useState<boolean>(false);
    const handleOnSubmit: SubmitHandler<BookDemoFormFields> = (
        data: BookDemoFormFields,
        e?: React.BaseSyntheticEvent,
    ) => {
        e?.preventDefault();
        setIsBookRequested(true);
    };
    const { formatMessage } = useIntl();
    return (
        <form
            ref={ref}
            id={id}
            onSubmit={(e) => {
                handleSubmit(handleOnSubmit)(e);
            }}
        >
            {!isBookRequested ? (
                <>
                    <TextInput
                        placeholder={formatMessage({
                            id: "index_page.form.name",
                        })}
                        {...register("firstName", { required: true })}
                    />
                    <TextInput
                        placeholder={formatMessage({
                            id: "index_page.form.company_name",
                        })}
                        {...register("companyName", { required: true })}
                    />
                    <TextInput
                        type='email'
                        placeholder={formatMessage({
                            id: "index_page.form.email",
                        })}
                        {...register("email", { required: true })}
                    />
                    <StyledFormButton type='submit' as='button'>
                        <FormattedMessage id={"index_page.form.submit_button"} />
                    </StyledFormButton>
                </>
            ) : (
                <div>
                    <p>
                        <FormattedMessage id='index_page.form.success_message' />
                    </p>
                </div>
            )}
        </form>
    );
});
BookDemoForm.displayName = "BookDemoForm";
export default BookDemoForm;
